import { stringifyGraph } from '@/clients/http'
import { CustomerModel } from '@/http/models/customer'

import { UseFetchListForm, useFetchList } from '@/hooks/useFetchList'

import { CustomerHttpParams, CustomerModel as CustomerModelType, CustomerResponses } from '@/types'

export interface CustomerListFilters {
  search?: string
  status?: 'active' | 'inactive' | 'all' | null
}

export interface CustomerListForm extends UseFetchListForm<
  CustomerListFilters,
  CustomerModelType.Customer
> {}

interface UseFetchCustomersProps {
  sort?: string | null
  shouldFetchList?: boolean
}

export const customerInitialFilters: CustomerListFilters = {
  search: '',
  status: 'all',
}

export const useFetchCustomers = ({ sort, shouldFetchList }: UseFetchCustomersProps) => {
  return useFetchList<
    CustomerListFilters,
    CustomerModelType.Customer,
    {},
    any,
    typeof CustomerModel.getList
  >({
    pageSize: 10,
    initialFilters: customerInitialFilters,
    fetchFunction: CustomerModel.getList,
    sort,
    register: shouldFetchList,
    buildQueryParams: (filters): Partial<CustomerHttpParams.GetList['query']> => ({
      search: filters.search || undefined,
      status: filters.status === 'all' ? undefined : filters.status,
      graph_enc: stringifyGraph({
        '*': true,
        roles: {
          '*': true,
        },
        image: {
          path: true,
          versions: true,
        },
      }),
    }),
    buildParams: () => ({}),
  })
}
